<template>
  <div class="contact_us">
    <v-container>
      <v-row justify="center">
        <v-col md="6">
          <h1 class="mb-6">Contact Us</h1>
          
          <v-form @submit.prevent="sendForm">
            <v-text-field
              v-model="email"
              type="text"
              autocomplete="email"
              label="Your E-mail"
              outlined
              :rules="emailRules"
              class="my-3"
            ></v-text-field>
            
            <v-textarea
              v-model="message"
              label="Message"
              :rules="messageRules"
              :counter="this.messageMaxSize"
              outlined
              class="my-3"
            ></v-textarea>
            
            <v-btn color="primary" type="submit">Send</v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import validators from "@/utils/validators";
import apiClient from "@/utils/apiClient";

const messageMaxSize = 500

export default {
  data: () => ({
    email: "",
    message: "",
    
    emailRules: [
      value => !!value || "Required",
      value => validators.isEmail(value) || "Invalid e-mail",
    ],
    messageRules: [
      value => !!value || "Required",
      value => value.length < messageMaxSize || "Maximum " + messageMaxSize.toString() + " characters",
    ],
    messageMaxSize: messageMaxSize
  }),
  computed: {
    form() {
      return {
        email: this.email,
        message: this.message,
      }
    }
  },
  methods: {
    sendForm() {
      if (!this.isFormValid())
        return;
  
      apiClient
        .sendContactUsMessage(this.form)
        .then(() => {
          this.email = ""
          this.message = ""
        })
        .catch((error) => {
          console.log(error)
        })
    },
    
    isFormValid() {
      return this.emailRules.every(validation => validation(this.email) === true)
        && this.messageRules.every(validation => validation(this.message) === true)
    },
  },
}
</script>
